/**
 * Lead Qualification Service - SOP #1
 * Frontend service for lead qualification operations
 */

import api from "../../../shared/api.jsx";

/**
 * Check lead qualification/completeness
 * @param {string} leadId - Lead ID
 * @returns {Promise<Object>} Qualification result
 */
export const checkQualification = async (leadId) => {
  try {
    const response = await api.post(`/leads/${leadId}/qualification/check`);
    return response.data;
  } catch (error) {
    console.error("Error checking qualification:", error);
    throw error;
  }
};

/**
 * Validate required fields on client side
 * @param {Object} leadData - Lead data object
 * @returns {Object} { valid: boolean, missingFields: string[] }
 */
export const validateRequiredFields = (leadData) => {
  const requiredFields = [
    { key: "name", label: "Customer Name" },
    { key: "phone", label: "Contact Number" },
    { key: "moving_from", label: "Pickup Address" },
    { key: "moving_to", label: "Drop-off Address" },
    { key: "items", label: "Item List/Photos" },
  ];

  const missingFields = [];

  for (const field of requiredFields) {
    const value = leadData[field.key];

    // Special handling for items - must be array with at least one item
    if (field.key === "items") {
      if (!Array.isArray(value) || value.length === 0) {
        missingFields.push(field.label);
      }
    } else {
      // For other fields, check if value exists and is not empty
      if (!value || (typeof value === "string" && value.trim() === "")) {
        missingFields.push(field.label);
      }
    }
  }

  return {
    valid: missingFields.length === 0,
    missingFields,
  };
};
